/* import __COLOCATED_TEMPLATE__ from './input-main-area.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import { modifier } from 'ember-modifier';

var watchInputPanelSize = function () {
  let relativeInputPanel = document.getElementById('input-container');
  let width = relativeInputPanel.getBoundingClientRect().width;
  if (width < 497) {
    document.getElementById('partSelector').classList.add('narrow');
    document.getElementById('partSelectContent').classList.add('narrow');
    if (document.getElementById('selectorDropdown')) {
      document.getElementById('selectorDropdown').classList.add('narrow');
    }
    document.getElementById('input-panel').classList.add('narrow');
    document.getElementById('inputSignalPanel').classList.add('narrow');
    return true;
  } else {
    document.getElementById('partSelector').classList.remove('narrow');
    document.getElementById('partSelectContent').classList.remove('narrow');
    if (document.getElementById('selectorDropdown')) {
      document.getElementById('selectorDropdown').classList.remove('narrow');
    }
    document.getElementById('input-panel').classList.remove('narrow');
    document.getElementById('inputSignalPanel').classList.remove('narrow');
    return false;
  }
};

////////////////////////////////////////////////////////////////////////////////////
// input-main-area - Section containing user inputs used by the application       //
////////////////////////////////////////////////////////////////////////////////////

export default class InputMainArea extends Component {
  tagName = '';
  inputPanelElement = null;
  @service intl;
  boundResizeListener = null;
  currentSchematic = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Modifier                                                                   //
  ////////////////////////////////////////////////////////////////////////////////

  setCurrentSchematic = modifier((_element, [selectedSchematic]) => {
    this.set('currentSchematic', selectedSchematic);
  });

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  inputChange(inputSignalChanged) {
    if (this.updateModel) {
      this.updateModel(inputSignalChanged);
    }
  }

  resize() {
    this.set('isNarrow', watchInputPanelSize());
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertingInputPanel(elem) {
    this.inputPanelElement = elem;
    var self = this;
    this.resize();
    this.boundResizeListener = this.resize.bind(this);
    window.addEventListener('resize', this.boundResizeListener);

    setTimeout(function () {
      if (!self.isDestroying && !self.isDestroyed) {
        self.inputChange(false);
      }
    }, 200);
  }

  @action destroyingInputPanel() {
    window.removeEventListener('resize', this.boundResizeListener);
    this.inputPanelElement = null;
  }

  @action reset() {
    this.model.setInputs();
    this.inputChange(true);
  }

  @action updateField(fieldName, fieldValue, refresh) {
    this.model.set(fieldName, fieldValue);
    if (refresh) refresh();
    this.inputChange(false);
  }

  @action updateInputSignal(fieldName, fieldValue) {
    this.model.set(fieldName, fieldValue);
    this.inputChange(true);
  }

  @action updateSelectedPart(fieldName, fieldValue) {
    this.model.set(fieldName, fieldValue);

    // Refresh to default inputs if the schematic has changed
    if (this.model.selectedSchematic != this.currentSchematic) {
      this.model.setInputs();
      this.set('currentSchematic', this.model.selectedSchematic);
    }

    this.inputChange(true);
  }

  @action refreshGainForSelectedPart() {
    this.model.refreshGainForSelectedPart();
  }
}
